// removed by extract-text-webpack-plugin
module.exports = {"PopupBox":"_2QhgN0NfJ_3TdCYzmyWAYG","PopupBox--error":"_59Wnuxbe1KlKCgU0iVyHU","jiggle":"_2BkiwUp3Fge8XYX_ygmhwk","PopupBox__inner":"_2gc3eTvErXhAMaVYXxQBb4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PopupBox/PopupBox.scss
// module id = 2684
// module chunks = 0